import React from 'react'
import PropTypes from 'prop-types'

// Components
import {Button, routeTypes} from '@/components/ui/button'
import ChevronDown from 'hec/assets/icons/chevron-down'

// Helpers
import {buildCategoryLink} from 'hec/helpers/sfccHelpers'
import {useAppOrigin} from '~/app/hooks/use-app-origin'
import {cn} from '@/lib/utils'

const CategoryLink = ({
    categoryID,
    categoryName,
    altCategoryUrl = null,
    hasSubCategories = false,
    shopAll = false,
    open
}) => {
    const appOrigin = useAppOrigin()
    const categoryUrl =
        altCategoryUrl ||
        buildCategoryLink({
            appOrigin: appOrigin,
            categoryID: categoryID
        })

    return (
        <Button
            className={cn(
                'text-blue-05 flex justify-between items-center pt-[0.625rem] pr-[0.5rem] pb-[0.4375rem] pl-[1.25rem]',
                {
                    'hover:[text-shadow:_0_0_0.0625rem_#132744] focus:[text-shadow:_0_0_0.0625rem_#132744]':
                        hasSubCategories,
                    'hover:bg-accent hover:text-white hover:rounded-lg hover:no-underline':
                        !hasSubCategories,
                    'font-grotesque font-medium': shopAll,
                    '[text-shadow:_0_0_0.0625rem_#132744]': open
                }
            )}
            ctaType="link"
            routeType={routeTypes.EXTERNAL}
            hrefValue={hasSubCategories ? null : categoryUrl}
            asChild
            data-testid="categoryLink-Button"
        >
            {categoryName}
            {hasSubCategories ? <ChevronDown className="w-3 h-[0.4375rem]" /> : ''}
        </Button>
    )
}

CategoryLink.propTypes = {
    categoryID: PropTypes.string.isRequired,
    categoryName: PropTypes.string.isRequired,
    altCategoryUrl: PropTypes.string,
    hasSubCategories: PropTypes.bool,
    shopAll: PropTypes.bool,
    open: PropTypes.bool
}

export default CategoryLink
